import React from 'react'
import moment from 'moment'
import momentJalali from 'moment-jalaali'
import { Grid, Typography, Rating } from '@mui/material'
import PidoImage from '../../../assets/images/logo.png'
import useStyles from './styles'

function InfoRating(props) {
    const classes = useStyles()
    const clickRating = (e, v) => {
        props.setScore(v)
        props.setState(1)
        if (v < 3) {
            props.setRatingTab(1)
        } else {
            props.setRatingTab(0)
        }
    }

    const miladi_jalali = (datetime) => {
        if (moment(datetime).isValid()) {
            let time = moment(datetime).format('HH:mm:ss')
            let date = moment(datetime).format('YYYY-MM-DD')
            date = momentJalali(date).format('jYYYY/jMM/jDD')
            return time + ' | ' + date
        } else return ''
    }

    return (
        <React.Fragment>
            <Grid className={classes.title}>
                <Typography variant="h1">
                    به درخواست امتیاز دهید
                </Typography>
            </Grid>
            <Grid className={classes.root}>
                <img
                    src={PidoImage}
                    alt={"Pido"}
                    className={classes.operatorImage}
                />
                <Typography variant="body1" style={{ marginBottom: 15 }}>
                    {props.receipt.vOperatorName}
                </Typography>
                <Typography variant="h5" style={{ marginBottom: 15 }}>
                    {props.receipt.iVolumeReceived} {' لیتر '} {props.receipt.vFuelInfoTitle}
                </Typography>
                <Typography variant="body1" style={{ marginBottom: 15 }}>
                    {miladi_jalali(props.receipt.dtAddAt)}
                </Typography>
                <Rating
                    name="rating"
                    defaultValue={props.score}
                    size="large"
                    style={{
                        fontSize: 50,
                        direction: 'rtl',
                        marginBottom: 20,
                        marginTop: 20
                    }}
                    value={props.score}
                    onChange={(e, v) => clickRating(e, v)}
                />
                <Typography variant="body1" style={{ marginTop: 100 }}>
                    نظر شما با حفظ حریم شخصی‌تان ثبت می‌شود
                </Typography>
            </Grid>
        </React.Fragment>
    )
}

export default InfoRating

